import { render, staticRenderFns } from "./work-form-select.vue?vue&type=template&id=5edee9bf&"
import script from "./work-form-select.vue?vue&type=script&lang=js&"
export * from "./work-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports